/**
 * Compañías con grabación de backup en call center (LiveKit, outbound e inbound).
 * Agregar IDs al array para habilitar más compañías sin cambiar la lógica.
 */
export const CALL_CENTER_BACKUP_RECORDING_COMPANY_IDS = [
  86496225,
];

export function isCallCenterBackupEnabled(companyId) {
  return CALL_CENTER_BACKUP_RECORDING_COMPANY_IDS.includes(Number(companyId));
}

/** type_id 7 y 9 = inbound; el resto es outbound. */
export function callCenterBackupDirection(typeId) {
  const id = Number(typeId);
  return id === 7 || id === 9 ? 'inbound' : 'outbound';
}



// WEBPACK FOOTER //
// ./src/services/callRecording/config.js